import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

export interface FavoriteButtonProps {
  active: boolean;
  onToggle: () => void;
  ariaLabel: string;
  disabled?: boolean;
  testId?: string;
  className?: string;
}

/**
 * Star toggle: the outline glyph with the solid one faded in on top while
 * active. The 40px box is the hit area; the glyph itself is smaller.
 */
export const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  active,
  onToggle,
  ariaLabel,
  disabled = false,
  testId,
  className,
}) => (
  <button
    type="button"
    className={classNames(styles.button, active && styles.active, className)}
    aria-label={ariaLabel}
    aria-pressed={active}
    disabled={disabled}
    onClick={onToggle}
    data-testid={testId}
  >
    <i className="icon-star-regular" aria-hidden="true" />
    <i className={classNames('icon-star-solid', styles.solid)} aria-hidden="true" />
  </button>
);

export default FavoriteButton;
